import { entity as E } from "./schema.js";
export const confectionery = {
"BB-CNF-01": [
E("cnf_recipe", "Confectionery recipe", "A versioned formula for a finished confectionery item.", `item_id|>inv_item.item_id|Finished product
recipe_code|CODE(40)|Product recipe reference
revision|INTEGER|Formula version
yield_qty|QTY|Expected batch yield
yield_uom|CODE(16)|Output unit
valid_from|DATE|Effective date`, ["item_id,recipe_code,revision"], "Approved formula revisions remain immutable; yield losses require explicit treatment."),
E("cnf_recipe_ingredient", "Recipe ingredient", "Ingredient amount required for one formula yield.", `recipe_id|>cnf_recipe.id|Formula revision
line_no|INTEGER|Ingredient sequence
item_id|>inv_item.item_id|Ingredient inventory item
quantity|QTY|Required quantity
uom|CODE(16)|Ingredient measure
addition_stage|CODE(40)|Stage at which ingredient is added`, ["recipe_id,line_no"], "Unit conversions and ingredient substitutions require reviewed definitions."),
E("cnf_recipe_instruction", "Recipe processing instruction", "An ordered preparation step with reviewed operating targets.", `recipe_id|>cnf_recipe.id|Formula revision
step_no|INTEGER|Processing sequence
instruction|TEXT(1000)|Preparation instruction
target_minutes|QTY?|Target duration in minutes
target_temperature|QTY?|Target temperature in Celsius`, ["recipe_id,step_no"], "Targets are manufacturing documentation; product safety validation is separate.")
],
"BB-CNF-02": [
E("cnf_ingredient_spec", "Ingredient specification", "An approved specification revision for an ingredient item.", `item_id|>inv_item.item_id|Ingredient
spec_code|CODE(40)|Specification reference
revision|INTEGER|Revision number
valid_from|DATE|Effective date
status|CODE(20)|Draft, approved or retired`, ["item_id,spec_code,revision"], "Supplier approval is not established by holding a specification record."),
E("cnf_ingredient_characteristic", "Ingredient characteristic", "A required compositional or physical property.", `spec_id|>cnf_ingredient_spec.id|Specification revision
characteristic|CODE(60)|Property such as cocoa_solids or moisture
minimum_value|QTY?|Lower permitted value
maximum_value|QTY?|Upper permitted value
uom|CODE(16)?|Measurement unit
method_ref|TEXT(120)|Test method revision`, ["spec_id,characteristic"], "Limits are examples to be supplied by the modeler; no safety thresholds are shipped."),
E("cnf_supplier_ingredient", "Supplier ingredient offer", "A supplier's item reference mapped to an ingredient specification.", `supplier_id|>sup_account.supplier_id|Supplying account
spec_id|>cnf_ingredient_spec.id|Agreed specification
supplier_item_code|CODE(60)|Supplier catalogue reference
valid_from|DATE|Agreement start
review_reference|TEXT(120)|Qualification evidence reference`, ["supplier_id,supplier_item_code,valid_from"], "A supplier item code is scoped to its supplier and effective period.")
],
"BB-CNF-03": [
E("cnf_batch", "Confectionery batch", "One production occurrence of a released recipe revision.", `recipe_id|>cnf_recipe.id|Executed formula
batch_number|CODE(50)|Manufacturing batch reference
started_at|INSTANT|Batch start
completed_at|INSTANT?|Batch completion
status|CODE(20)|Planned, running, completed or held`, ["batch_number"], "Batch reference scope is the confectionery manufacturing business."),
E("cnf_batch_input", "Batch input lot", "Actual ingredient or intermediate lot consumed by a batch.", `batch_id|>cnf_batch.id|Consuming batch
line_no|INTEGER|Consumption sequence
lot_id|>inv_lot.lot_id|Input inventory lot
quantity|QTY|Consumed quantity
uom|CODE(16)|Consumed unit`, ["batch_id,line_no"], "Actual input lots preserve genealogy even when recipe substitutions occur."),
E("cnf_batch_output", "Batch output lot", "A finished or intermediate inventory lot produced by a batch.", `batch_id|>cnf_batch.id|Producing batch
lot_id|>inv_lot.lot_id|Output lot
quantity|QTY|Produced quantity
uom|CODE(16)|Output unit
output_kind|CODE(20)|Finished, intermediate or rework`, ["batch_id,lot_id"], "Genealogy connects through shared lot identities; conservation requires unit conversion.")
],
"BB-CNF-04": [
E("cnf_production_run", "Confectionery production run", "A scheduled batch execution on confectionery equipment.", `batch_id|>cnf_batch.id|Planned or executing batch
run_number|CODE(40)|Run reference
asset_id|>ast_asset.asset_id|Primary processing equipment
planned_start|INSTANT|Scheduled start
planned_end|INSTANT|Scheduled finish`, ["run_number"], "Equipment capacity and hygiene changeovers constrain the schedule."),
E("cnf_run_stage", "Confectionery processing stage", "Actual preparation, cooking, cooling or finishing interval.", `run_id|>cnf_production_run.id|Production run
stage_no|INTEGER|Stage sequence
stage_name|CODE(40)|Mixing, cooking, cooling or finishing
started_at|INSTANT?|Actual start
finished_at|INSTANT?|Actual finish
operator_id|>org_employee.employee_id|Responsible employee`, ["run_id,stage_no"], "Stage sequence and process limits are site-specific."),
E("cnf_run_loss", "Confectionery production loss", "Measured loss at a processing stage.", `stage_id|>cnf_run_stage.id|Observed stage
loss_no|INTEGER|Loss event sequence
reason|CODE(40)|Spillage, evaporation, scrap or rework
quantity|QTY|Lost or diverted amount
uom|CODE(16)|Measure unit`, ["stage_id,loss_no"], "Rework must be traceable separately from irrecoverable scrap.")
],
"BB-CNF-05": [
E("cnf_allergen", "Allergen reference", "A controlled term used in reviewed ingredient declarations.", `code|CODE(40)|Allergen vocabulary identifier
name|TEXT(120)|Human-readable term
vocabulary|TEXT(120)|Source vocabulary and version
status|CODE(20)|Active or retired`, ["vocabulary,code"], "No jurisdictional allergen list is implied or hard-coded."),
E("cnf_allergen_declaration", "Ingredient allergen declaration", "A supplier-backed declaration for an ingredient specification.", `spec_id|>cnf_ingredient_spec.id|Ingredient specification
allergen_id|>cnf_allergen.id|Declared allergen
presence|CODE(30)|Contains, possible_contact or assessed_absent
evidence_ref|TEXT(200)|Declaration evidence
reviewed_on|DATE|Review date`, ["spec_id,allergen_id"], "Absence of a declaration is unknown, not assessed absence."),
E("cnf_recipe_allergen_review", "Recipe allergen review", "An assessed recipe association and handling requirement.", `recipe_id|>cnf_recipe.id|Recipe revision
allergen_id|>cnf_allergen.id|Assessed allergen
review_revision|INTEGER|Review version
handling_instruction|TEXT(1000)|Reviewed handling requirement
evidence_ref|TEXT(200)|Calculation and cross-contact review`, ["recipe_id,allergen_id,review_revision"], "Ingredient aggregation alone cannot establish safe absence or correct labeling.")
],
"BB-CNF-06": [
E("cnf_quality_plan", "Confectionery quality plan", "A revisioned inspection plan for an inventory item.", `item_id|>inv_item.item_id|Inspected product or ingredient
plan_code|CODE(40)|Quality-plan identifier
revision|INTEGER|Plan version
sampling_instruction|TEXT(1000)|Reviewed sampling procedure`, ["item_id,plan_code,revision"], "Acceptance limits must be supplied by qualified product specialists."),
E("cnf_quality_result", "Confectionery quality result", "A sample result on a specific inventory lot.", `plan_id|>cnf_quality_plan.id|Inspection plan
lot_id|>inv_lot.lot_id|Sampled lot
sample_reference|CODE(60)|Sample identifier
characteristic|CODE(60)|Measured property
value_text|TEXT(200)|Reported measurement
uom|CODE(16)?|Measurement unit
outcome|CODE(20)|Pass, fail or inconclusive`, ["plan_id,lot_id,sample_reference,characteristic"], "Results retain their plan version and do not automatically release stock."),
E("cnf_quality_disposition", "Confectionery lot disposition", "A reviewed release, hold or rejection for inspected material.", `result_id|>cnf_quality_result.id|Supporting result
decision_no|INTEGER|Decision sequence
decision|CODE(20)|Release, hold or reject
reviewer_id|>org_employee.employee_id|Decision maker
decided_at|INSTANT|Decision time`, ["result_id,decision_no"], "A release must consider all required test results for the lot.")
],
"BB-CNF-07": [
E("cnf_pack_spec", "Confectionery packaging specification", "A versioned pack configuration for a finished item.", `item_id|>inv_item.item_id|Finished product
pack_code|CODE(40)|Pack configuration
revision|INTEGER|Packaging revision
units_per_pack|QTY|Product units in one sale pack
pack_uom|CODE(16)|Sale pack measure`, ["item_id,pack_code,revision"], "Pack dimensions, food contact suitability and legal declarations require separate review."),
E("cnf_label", "Confectionery label version", "Label artwork and reviewed declaration tied to a pack revision.", `pack_spec_id|>cnf_pack_spec.id|Pack configuration
label_revision|INTEGER|Artwork revision
artwork_reference|TEXT(250)|Managed artwork reference
valid_from|DATE|Effective date
approval_reference|TEXT(120)|Label approval evidence`, ["pack_spec_id,label_revision"], "A label reference does not certify its contents or language coverage."),
E("cnf_pack_run", "Confectionery packing run", "A packing occurrence consuming finished output and packaging material.", `batch_id|>cnf_batch.id|Source product batch
label_id|>cnf_label.id|Applied label version
run_number|CODE(40)|Packing run reference
packed_quantity|QTY|Number of sale packs
packed_at|INSTANT|Packing time`, ["run_number"], "Product genealogy remains linked to the source batch."),
E("cnf_pack_consumption", "Packing material consumption", "Packaging lot usage during a packing run.", `run_id|>cnf_pack_run.id|Packing run
lot_id|>inv_lot.lot_id|Packaging material lot
quantity|QTY|Material quantity used
uom|CODE(16)|Material unit`, ["run_id,lot_id"], "Packaging waste is reconciled with issued material separately.")
],
"BB-CNF-08": [
E("cnf_storage_condition", "Confectionery storage condition", "A reviewed storage-condition profile.", `condition_code|CODE(40)|Condition reference
revision|INTEGER|Profile version
temperature_min|QTY?|Minimum Celsius temperature
temperature_max|QTY?|Maximum Celsius temperature
instruction|TEXT(1000)|Storage and humidity instruction`, ["condition_code,revision"], "Limits are user-supplied validated product requirements."),
E("cnf_shelf_life", "Lot shelf-life assignment", "The reviewed production and expiry dates for a lot.", `lot_id|>inv_lot.lot_id|Inventory lot
condition_id|>cnf_storage_condition.id|Required storage profile
produced_on|DATE|Manufacture date
expires_on|DATE|Assigned expiry date
assessment_ref|TEXT(120)|Shelf-life evidence reference`, ["lot_id"], "Expiry is not inferred without validated product stability evidence."),
E("cnf_expiry_action", "Expiry disposition event", "A reviewed action for a lot approaching or beyond expiry.", `shelf_life_id|>cnf_shelf_life.id|Assigned shelf life
event_no|INTEGER|Action sequence
action|CODE(30)|Hold, withdraw, destroy or reviewed_extension
acted_at|INSTANT|Action time
evidence_ref|TEXT(200)|Decision and disposition evidence`, ["shelf_life_id,event_no"], "Extensions require new authorized evidence and must retain prior dates.")
],
"BB-CNF-09": [
E("cnf_stock_zone", "Confectionery storage zone", "A shared stock location with an approved storage profile.", `location_id|>inv_location.stock_location_id|Inventory location
condition_id|>cnf_storage_condition.id|Storage profile
zone_kind|CODE(30)|Ingredients, packaging, intermediate or finished
segregation_instruction|TEXT(500)|Separation or allergen handling instruction`, ["location_id"], "Zone classifications supplement shared inventory locations without duplicating them."),
E("cnf_zone_observation", "Storage condition observation", "A measurement recorded in a storage zone.", `zone_id|>cnf_stock_zone.id|Monitored zone
observed_at|INSTANT|Measurement timestamp
sensor_reference|CODE(60)|Measurement source
temperature_c|QTY?|Observed Celsius temperature
humidity_percent|PCT?|Relative humidity`, ["zone_id,observed_at,sensor_reference"], "An observation needs reviewed limits before classifying a deviation."),
E("cnf_stock_allocation", "Confectionery stock allocation", "A lot reservation with an assessed picking sequence.", `lot_id|>inv_lot.lot_id|Reserved lot
reservation_id|>inv_reservation.reservation_id|Shared reservation
zone_id|>cnf_stock_zone.id|Holding zone
pick_priority|INTEGER|Assessed pick sequence
expiry_checked_on|DATE|Date of expiry check`, ["lot_id,reservation_id"], "FEFO recommendations must respect lot release, segregation and customer constraints.")
],
"BB-CNF-10": [
E("cnf_purchase", "Confectionery purchase agreement", "A supplier order for ingredients or packaging.", `supplier_id|>sup_account.supplier_id|Supplier account
order_number|CODE(40)|Purchase reference
ordered_on|DATE|Order date
currency|CODE(3)|Purchase currency`, ["order_number"], "Specifications and food contact requirements must be agreed with the supplier."),
E("cnf_purchase_line", "Confectionery purchase line", "An ordered ingredient or packaging item.", `purchase_id|>cnf_purchase.id|Purchase order
line_no|INTEGER|Order sequence
item_id|>inv_item.item_id|Ordered item
quantity|QTY|Ordered quantity
uom|CODE(16)|Order unit
unit_price|MONEY|Price in purchase currency`, ["purchase_id,line_no"], "Received quantities may be split across lots and deliveries."),
E("cnf_supplier_receipt", "Confectionery supplier receipt", "A received lot and supplier evidence for a purchase line.", `line_id|>cnf_purchase_line.id|Purchased line
receipt_reference|CODE(60)|Receipt reference
lot_id|>inv_lot.lot_id|Received lot
quantity|QTY|Received quantity
received_at|INSTANT|Receipt timestamp
invoice_reference|TEXT(120)?|Supplier invoice reference`, ["receipt_reference"], "Receipt, quality release and invoice settlement are separate facts.")
],
"BB-CNF-11": [
E("cnf_distribution_order", "Confectionery distribution requirement", "Shelf-life and packing requirements supplementing a shared sales order.", `order_id|>sal_order.order_id|Sales order
minimum_remaining_days|INTEGER|Required remaining shelf life at delivery
pack_instruction|TEXT(500)|Customer packaging instruction
delivery_on|DATE|Requested arrival date`, ["order_id"], "Shelf-life requirements are checked at planned delivery, not only at dispatch."),
E("cnf_dispatch_allocation", "Confectionery lot dispatch", "A product lot assigned to an order line and shipment.", `order_line_id|>sal_order_line.order_line_id|Sales line
lot_id|>inv_lot.lot_id|Allocated product lot
shipment_line_id|>sal_shipment_line.shipment_line_id|Shipment line
quantity|QTY|Allocated quantity`, ["order_line_id,lot_id,shipment_line_id"], "Only released and suitable lots may be dispatched."),
E("cnf_return_assessment", "Confectionery return assessment", "An inspection and disposition of returned product.", `return_id|>sal_return.return_id|Shared sales return
lot_id|>inv_lot.lot_id|Returned lot
assessment_no|INTEGER|Assessment sequence
condition_text|TEXT(500)|Observed package and storage condition
disposition|CODE(20)|Hold, destroy or approved_restock`, ["return_id,lot_id,assessment_no"], "Returns must not be restocked solely because the packaging appears intact.")
],
"BB-CNF-12": [
E("cnf_recipe_cost", "Recipe cost estimate", "A dated formula-cost estimate in a stated currency.", `recipe_id|>cnf_recipe.id|Costed recipe revision
as_of|DATE|Costing date
currency|CODE(3)|Estimate currency
yield_cost|MONEY|Cost of the recipe yield
price_basis|TEXT(120)|Ingredient price source`, ["recipe_id,as_of,currency"], "Estimate excludes unmodeled local overhead and taxes."),
E("cnf_batch_cost", "Confectionery actual batch cost", "An actual cost component for a produced batch.", `batch_id|>cnf_batch.id|Costed batch
line_no|INTEGER|Cost component
account_id|>fin_account.account_id|Cost ledger account
cost_kind|CODE(30)|Ingredient, labor, packaging, waste or overhead
amount|MONEY|Assessed cost
currency|CODE(3)|Cost currency`, ["batch_id,line_no"], "Waste and rework must not be charged twice in batch totals."),
E("cnf_cost_posting", "Confectionery cost posting", "A recorded journal association for actual batch costs.", `batch_cost_id|>cnf_batch_cost.id|Cost component
journal_id|>fin_journal.journal_id|Posted ledger journal
amount|MONEY|Posted component amount
posted_at|INSTANT|Posting time`, ["batch_cost_id,journal_id"], "Ledger approval, valuation policy and balanced posting remain runtime controls.")
]
};
